// Feature Configurations
import { useLocation } from 'react-router-dom';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import { NavigationLink } from '../Types/NavigationLink';

function shouldShowSubMenu(subMenus: NavigationLink[], url: string): boolean | undefined {
    if (!subMenus?.length) return;
    const { pathname } = useLocation();
    const isUrlSame = (subMenu) =>
        pathname.includes(subMenu.navigationItem.route.url) ||
        shouldShowSubMenu(subMenu.navigationItem.route?.childItems, url);

    return pathname.includes(url) || subMenus.some((subMenu: FeatureConfiguration) => isUrlSame(subMenu));
};

export default shouldShowSubMenu;
